import { canonicalSiteUrl } from "@softmax/web-addresses/discovery";
import type { loadForumPage } from "./forum/forum.data";

type ForumData = Awaited<ReturnType<typeof loadForumPage>>;

export function communityHead(metadata: ForumData["metadata"] | undefined) {
  if (!metadata) return {};

  const canonical = canonicalSiteUrl(metadata.canonical);
  return {
    meta: [
      { title: metadata.title },
      { name: "description", content: metadata.description },
      {
        name: "robots",
        content: `${metadata.index ? "index" : "noindex"},${metadata.follow ? "follow" : "nofollow"}`,
      },
      { property: "og:title", content: metadata.title },
      { property: "og:url", content: canonical },
      { property: "og:type", content: metadata.type },
    ],
    links: [{ rel: "canonical", href: canonical }],
  };
}
